import commonGetters from '@/store/data/common/getters'
import { get, isNil } from 'lodash'

const getters = {
    getSettingValue: state => params => {
        const item = get(state, `list.${params.settingName}`, null)
        return isNil(item) ? false : item
    },
    getSocioDemoValue: state => params => {
        const item = get(state, `sociodemo.${params.settingName}`, null)
        return isNil(item) ? false : item
    }
}

export default { ...commonGetters, ...getters }
